export const getDomainBounds = (domain) => {
    switch (domain) {
    case 'de':
        return {
            neLat: 55.1781815,
            neLon: 14.9318521,
            swLat: 47.0060938,
            swLon: 6.7033105
        };
    case 'fr':
        return {
            neLat: 51.0891285,
            neLon: 9.5597934,
            swLat: 41.3427780,
            swLon: -5.1422579
        };
    case 'ie':
        return {
            neLat: 55.7712184,
            neLon: -7.1779374,
            swLat: 51.0401947,
            swLon: -9.1641758
        };
    case 'us':
        return {
            neLat: 54.2335075,
            neLon: -69.4351731,
            swLat: 16.4393707,
            swLon: -111.3653281
        };
    default:
        return {
            neLat: 59.5000000,
            neLon: 2.0000000,
            swLat: 49.8200000,
            swLon: -10.8500000
        };
    }
};



// WEBPACK FOOTER //
// ./src/components/Header/MoveableDiv/SearchBar/data/index.js